import { IA_MODEL } from '@educabot/educablocks-boards';
import Tutorial1Step1 from '@sections/creabots/components/steps/Tutorial1Step1';
import AIVerifyLearningTutorial5Step20 from '@sections/creabots/components/steps/AIVerifyLearningTutorial5Step20';
import {
  BLOCK_CATEGORY_TYPE,
  BOARD_ID_TYPE,
  CODE_CHECK_TYPE,
  COMMON_CLASSES,
  AI_PROJECTS_TYPE,
  KIT_NAME,
  MODAL_TYPE,
  Project,
  TRAIN_STEPS,
} from '@sections/creabots/types/kits';
import * as routes from '@educabot/educablocks-cosmos';
import { getAIConfigForBlock, getAIElementForBlock } from '../config';
import TutorialSlider from '@sections/creabots/components/steps/TutorialSlider';
import { getTutorialImagesInfo } from '@sections/creabots/features/utils/getTutorialImagesInfo';

const intlPrefix = 'creabots.tutorials.ai.projects.smartTrashCan';
const imgBaseUrl = '/images/creabots/ai/projects/smartTrashCan';


export const smartTrashCan: Project = {
  id: 5,
  name: `${intlPrefix}.name`,
  description: `${intlPrefix}.description`,
  image: `${routes.bloquesUri}${imgBaseUrl}/project_image.png`, //missing image
  boardId: BOARD_ID_TYPE.AI,
  iaModelType: IA_MODEL.IMAGES,
  tutorial: [
    // Step 1.
    {
      step: {
        stepId: 0,
        modal: MODAL_TYPE.FULL,
        component: Tutorial1Step1,
        videoUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/labs/cesto-inteligente.mp4',
      },
    },
    // Step 2.
    {
      step: {
        stepId: 1,
        modal: MODAL_TYPE.FULL,
        component: TutorialSlider,
        images: getTutorialImagesInfo({
          kitName: KIT_NAME.AI,
          projectName: AI_PROJECTS_TYPE.SMART_TRASH_CAN,
          totalSteps: 24,
        }),
      },
    },
    // Step 3.
    {
      step: {
        stepId: 2,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step3`,
        image: `${imgBaseUrl}/steps/step3.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => /reciclable|recyclable|reciclável/i.test(obj.samples.class0?.name?.toLowerCase() || ''),
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#mlClass-0',
            xOffset: 40,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 4.
    {
      step: {
        stepId: 3,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step4`,
        image: `${imgBaseUrl}/steps/step4.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samplesModalActive === 'class0',
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#ml-takeSample-0',
            xOffset: 40,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 5.
    {
      step: {
        stepId: 4,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step5`,
        image: `${imgBaseUrl}/steps/step5.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class0?.image?.length > 0,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 6.
    {
      step: {
        stepId: 5,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step6`,
        image: `${imgBaseUrl}/steps/step6.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class0?.image?.length > 1,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 7.
    {
      step: {
        stepId: 6,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step7`,
        image: `${imgBaseUrl}/steps/step7.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class0?.image?.length > 2,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 8.
    {
      step: {
        stepId: 7,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step8`,
        image: `${imgBaseUrl}/steps/step8.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class0?.image?.length > 3,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 9.
    {
      step: {
        stepId: 8,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step9`,
        image: `${imgBaseUrl}/steps/step9.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => !obj.samplesModalActive,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#load-samples-btn',
            xOffset: 40,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 10.
    {
      step: {
        stepId: 9,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step10`,
        image: `${imgBaseUrl}/steps/step10.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => Object.keys(obj.samples).includes('class1'),
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#add-class-btn',
            xOffset: 70,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 11.
    {
      step: {
        stepId: 10,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step11`,
        image: `${imgBaseUrl}/steps/step11.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => /no[ ]?reciclable|non[ |-]?recyclable|não[ ]?reciclável/i.test(obj.samples.class1?.name?.toLowerCase() || ''),
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#mlClass-1',
            xOffset: 40,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 12.
    {
      step: {
        stepId: 11,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step12`,
        image: `${imgBaseUrl}/steps/step12.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samplesModalActive === 'class1',
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#ml-takeSample-1',
            xOffset: 40,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 13.
    {
      step: {
        stepId: 12,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step13`,
        image: `${imgBaseUrl}/steps/step13.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class1?.image?.length > 0,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 14.
    {
      step: {
        stepId: 13,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step14`,
        image: `${imgBaseUrl}/steps/step14.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class1?.image?.length > 1,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 15.
    {
      step: {
        stepId: 14,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step15`,
        image: `${imgBaseUrl}/steps/step15.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class1?.image?.length > 2,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 16.
    {
      step: {
        stepId: 15,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step16`,
        image: `${imgBaseUrl}/steps/step16.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.samples.class1?.image?.length > 3,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#capture-btn',
            xOffset: 0,
            yOffset: 0,
          },
        },
      ],
    },
    // Step 17.
    {
      step: {
        stepId: 16,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step17`,
        image: `${imgBaseUrl}/steps/step17.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => !obj.samplesModalActive,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#load-samples-btn',
            xOffset: 40,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 18.
    {
      step: {
        stepId: 17,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step18`,
        image: `${imgBaseUrl}/steps/step18.png`,
        iaStep: TRAIN_STEPS.TEACH,
        completionCode: (obj) => obj.trainingStep === TRAIN_STEPS.TRAIN,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#ml-train',
            xOffset: 15,
            yOffset: -20,
          },
        },
      ],
    },
    // Step 19.
    {
      step: {
        stepId: 18,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step19`,
        image: `${imgBaseUrl}/steps/step19.png`,
        iaStep: TRAIN_STEPS.TRAIN,
        completionCode: (obj) => obj.modelTrained === true,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#train-btn',
            xOffset: -3,
            yOffset: -12,
          },
        },
      ],
    },
    // Step 20.
    {
      step: {
        stepId: 19,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step20`,
        image: `${imgBaseUrl}/steps/step20.png`,
        iaStep: TRAIN_STEPS.TRAIN,
        completionCode: (obj) => obj.trainingStep === TRAIN_STEPS.CLASSIFY,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#ml-analyze',
            xOffset: 15,
            yOffset: -20,
          },
        },
      ],
    },
    {
      step: {
        stepId: 19,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step20`,
        image: `${imgBaseUrl}/steps/step20.png`,
        iaStep: TRAIN_STEPS.CLASSIFY,
        completionCode: (obj) => obj.isClassifying === true,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#analyze-btn',
            xOffset: 132,
            yOffset: 142,
          },
        },
      ],
    },
    // Step 21.
    {
      step: {
        stepId: 20,
        modal: MODAL_TYPE.DOCKED,
        iaStep: TRAIN_STEPS.CLASSIFY,
        component: AIVerifyLearningTutorial5Step20,
      },
    },
    // Step 22.
    {
      step: {
        stepId: 21,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step22`,
        image: `${imgBaseUrl}/steps/step22.png`,
        iaStep: TRAIN_STEPS.CLASSIFY,
        completionCode: (obj) => obj.active === false,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#toggleBlocks',
            xOffset: -15,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 23.
    {
      step: {
        stepId: 22,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step23`,
        image: `${imgBaseUrl}/steps/step23.png`,
        ...getAIConfigForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        completionCode: 'voidsetup\\(\\)\\{servo_A0\\.attach\\(A0\\);[^}]*servo_A0.write\\(90\\);',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAIElementForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 45,
            yOffset: 10,
          },
        },
      ],
    },
    // Step 24.
    {
      step: {
        stepId: 23,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step24`,
        image: `${imgBaseUrl}/steps/step24.gif`,
        completionCodeCheck: CODE_CHECK_TYPE.BUILT,
      },
      hints: [
        {
          element: {
            image: `${routes.bloquesUri}/images/creabots/hint_big.png`,
            class: COMMON_CLASSES.BUILD_BLOCKLY_BTN_CLASS,
            xOffset: -26,
            yOffset: -35,
          },
        },
      ],
    },
    // Step 25.
    {
      step: {
        stepId: 24,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step25`,
        image: `${imgBaseUrl}/steps/step25.png`,
        ...getAIConfigForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        completionCode: 'if\\(command=="MLClass0"\\)\\{servo_A0.write\\(90\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAIElementForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 145,
            yOffset: 128,
          },
        },
      ],
    },
    {
      step: {
        stepId: 24,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step25`,
        image: `${imgBaseUrl}/steps/step25.png`,
        completionCode: 'if\\(command=="MLClass0"\\)\\{servo_A0.write\\(0\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 350,
            yOffset: 146,
          },
        },
      ],
    },
    // Step 26.
    {
      step: {
        stepId: 25,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step26`,
        image: `${imgBaseUrl}/steps/step26.png`,
        ...getAIConfigForBlock(BLOCK_CATEGORY_TYPE.DISPLAYS, 3),
        completionCode: 'if\\(command=="MLClass0"\\)\\{servo_A0.write\\(0\\);lcd.setCursor\\(0,0\\);lcd.print\\("abc"\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAIElementForBlock(BLOCK_CATEGORY_TYPE.DISPLAYS, 3),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 145,
            yOffset: 180,
          },
        },
      ],
    },
    {
      step: {
        stepId: 25,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step26`,
        image: `${imgBaseUrl}/steps/step26.png`,
        completionCode: 'if\\(command=="MLClass0"\\)\\{servo_A0.write\\(0\\);lcd.setCursor\\(0,0\\);lcd.print\\("reciclable|recyclable|reciclável"\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 270,
            yOffset: 195,
          },
        },
      ],
    },
    // Step 27.
    {
      step: {
        stepId: 27,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step27`,
        image: `${imgBaseUrl}/steps/step27.png`,
        ...getAIConfigForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        completionCode: 'if\\(command=="MLClass1"\\)\\{servo_A0.write\\(90\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAIElementForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 145,
            yOffset: 262,
          },
        },
      ],
    },
    // Step 28.
    {
      step: {
        stepId: 28,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step28`,
        image: `${imgBaseUrl}/steps/step28.png`,
        ...getAIConfigForBlock(BLOCK_CATEGORY_TYPE.DISPLAYS, 3),
        completionCode: 'if\\(command=="MLClass1"\\)\\{servo_A0.write\\(90\\);lcd.setCursor\\(0,0\\);lcd.print\\("abc"\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAIElementForBlock(BLOCK_CATEGORY_TYPE.DISPLAYS, 3),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 145,
            yOffset: 305,
          },
        },
      ],
    },
    {
      step: {
        stepId: 28,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step28`,
        image: `${imgBaseUrl}/steps/step28.png`,
        completionCode: 'if\\(command=="MLClass1"\\)\\{servo_A0.write\\(90\\);lcd.setCursor\\(0,0\\);lcd.print\\("no[ ]?reciclable|non[ |-]?recyclable|não[ ]?reciclável"\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 270,
            yOffset: 325,
          },
        },
      ],
    },
    // Step 29.
    {
      step: {
        stepId: 29,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step29`,
        image: `${imgBaseUrl}/steps/step29.png`,
        ...getAIConfigForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        completionCode: 'if\\(command=="MLC_Stop"\\)\\{servo_A0.write\\(90\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAIElementForBlock(BLOCK_CATEGORY_TYPE.MOTORS, 1),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 145,
            yOffset: 392,
          },
        },
      ],
    },
    // Step 30.
    {
      step: {
        stepId: 30,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step30`,
        image: `${imgBaseUrl}/steps/step30.png`,
        ...getAIConfigForBlock(BLOCK_CATEGORY_TYPE.DISPLAYS, 5),
        completionCode: 'if\\(command=="MLC_Stop"\\)\\{servo_A0.write\\(90\\);lcd.clear\\(\\);\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAIElementForBlock(BLOCK_CATEGORY_TYPE.DISPLAYS, 5),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 145,
            yOffset: 435,
          },
        },
      ],
    },
    // Step 31.
    {
      step: {
        stepId: 31,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step31`,
        image: `${imgBaseUrl}/steps/step31.gif`,
        completionCodeCheck: CODE_CHECK_TYPE.BUILT,
      },
      hints: [
        {
          element: {
            image: `${routes.bloquesUri}/images/creabots/hint_big.png`,
            class: COMMON_CLASSES.BUILD_BLOCKLY_BTN_CLASS,
            xOffset: -26,
            yOffset: -35,
          },
        },
      ],
    },
    // Step 32.
    {
      step: {
        stepId: 32,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step32`,
        image: `${imgBaseUrl}/steps/step32.png`,
        completionCode: (obj) => obj.active === true,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#toggleAI',
            xOffset: -15,
            yOffset: -15,
          },
        },
      ],
    },
    // Step 33.
    {
      step: {
        stepId: 33,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step33`,
        image: `${imgBaseUrl}/steps/step33.png`,
        iaStep: TRAIN_STEPS.CLASSIFY,
        completionCode: (obj) => obj.isClassifying === true,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#analyze-btn',
            xOffset: 132,
            yOffset: 142,
          },
        },
      ],
    },
    {
      step: {
        stepId: 33,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step33`,
        image: `${imgBaseUrl}/steps/step33.png`,
        iaStep: TRAIN_STEPS.CLASSIFY,
        completionCode: (obj) => obj.bluetooth.connected === true,
        completionCodeCheck: CODE_CHECK_TYPE.OBJECT_CONDITION,
      },
      hints: [
        {
          element: {
            class: '#MLConnectBluetooth',
            xOffset: 60,
            yOffset: -10,
          },
        },
      ],
    },
    // Step 34.
    {
      step: {
        stepId: 34,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step34`,
        image: `${imgBaseUrl}/steps/step34.png`,
        iaStep: TRAIN_STEPS.CLASSIFY,
      },
    },

  ],
};

/**
 * AI RULES: 
 * 
 * (obj) => obj.samples.class0?.image?.length > 0
 * (obj) => Object.values(obj.samples).some(sample => Array.isArray(sample.image) && sample.image?.length > 1)
 * (obj) => Object.values(obj.samples).every(sample => Array.isArray(sample.image) && sample.image?.length > 1)
 * (obj) => Object.values(obj.samples).some((s: any) => s.name && s.name.toLowerCase() === 'palma')
 * (obj) => obj.modelTrained === true
 * (obj) => obj.bluetooth.connected === true
 */
